<template>
    <Modal v-model="visible" :loading="modalLoading" closable mask-closable @on-ok="ok" :okText="getTranslation('k048')"
        cancelText=""  width="95" :fullscreen="true"  >
        <div :class="['record-header', { 'record-header-alarm': selectLibrary.AlarmCnt > 0 }]">
            <div class="header-item">
              <span class="header-label">{{ getTranslation('k261') }}</span>
              <span class="header-value header-code">{{ machine.code }}</span>
            </div>
            <span class="header-divider">|</span>
            <div class="header-item">
              <span class="header-label">{{ getTranslation('u045') }}</span>
              <span class="header-value">{{ productline.name }}</span>
            </div>
            <span class="header-divider">|</span>
            <div class="header-item">
              <span class="header-label">{{ getTranslation('k222') }}</span>
              <span class="header-value">{{ selectLibrary.created_string }}</span>
            </div>
            <span class="header-divider">|</span>
            <div class="header-item">
              <span class="header-label">{{ getTranslation('k259') }}</span>
              <span class="header-value">{{ selectLibrary.SpotId }}</span>
            </div>
            <span class="header-divider">|</span>
            <div class="header-item">
              <span class="header-label">{{ getTranslation('b006') }}</span>
              <span class="header-value">{{ selectLibrary.NoWeldProgram }}</span>
            </div>
            <span class="header-divider">|</span>
            <div class="header-item">
              <span class="header-label">{{ getTranslation('k230') }}</span>
              <span class="header-value">{{ selectLibrary.ValCurrentGun }}</span>
            </div>
            <span class="header-divider">|</span>
            <div class="header-item">
              <span class="header-label">{{ getTranslation('l005') }}</span>
              <span class="header-value" :class="{ 'header-alarm-value': selectLibrary.AlarmCnt > 0 }">{{ alarmList }}</span>
            </div>
        </div>
        
        <div class="tab-navigation-container">
            <div v-if="loading">
                <LoadingBar :height="'600px'"/>
            </div>
            <div v-show="!loading">
            <div class="nav-button nav-prev" @click="tabChange(-1)" :class="{ disabled: !canPre }">
                <Icon type="ios-arrow-back" />
            </div>
             
            <Tabs  type="card" class="custom-tabs" v-model="selectMode">
                <TabPane :label="getTranslation('r101')" name="m1" class="custom-tabpane">
                    <Row type="flex" class="normal-row">
                        <Col flex="1">{{ getTranslation('b006') }}:</Col>
                        <Col flex="2"><Input type="text" class="input-field" disabled
                            v-model="selectLibrary.NoWeldProgram" /></Col>
                        <Col flex="1">{{ getTranslation('b007') }}:</Col>
                        <Col flex="2"><Input type="text" class="input-field" disabled
                            v-model="selectLibrary.WeldProgram" />
                        </Col>
                        <Col flex="3">
                        </Col>
                    </Row>
                    <Row type="flex" class="normal-row">
                        <Col flex="1">{{ getTranslation('k269') }}:</Col>
                        <Col flex="2"><Input type="text" class="input-field" disabled
                            v-model="selectLibrary.PartName" />
                        </Col>
                        <Col flex="1">{{ getTranslation('k172') }}:</Col>
                        <Col flex="2"><Input type="text" class="input-field" disabled
                            v-model="selectLibrary.BatchNumber" />
                        </Col>
                        <Col flex="1">{{ getTranslation('u008') }}:</Col>
                        <Col flex="2"><Input type="text" class="input-field" disabled v-model="selectLibrary.Worker" />
                        </Col>
                    </Row>
                    <Card class="card-container" dis-hover>
                        <div slot="title" class="card-title">{{ getTranslation('r102') }}</div>
                        <div class="table">
                            <Row type="flex">
                                <Col flex="1" class="flex-middle">{{ getTranslation('k230') }}</Col>
                                <Col flex="1" class="flex-middle">{{ getTranslation('r014') }}</Col>
                                <Col flex="1" class="flex-middle">{{ getTranslation('r015') }}</Col>
                                <Col flex="1" class="flex-middle">{{ getTranslation('r016') }}</Col>
                                <Col flex="1" class="flex-middle">{{ getTranslation('r017') }}</Col>
                                <Col flex="1" class="flex-middle">{{ getTranslation('r018') }}</Col>
                                <Col flex="1" class="flex-middle">{{ getTranslation('r019') }}</Col>
                                <Col flex="1" class="flex-middle">{{ getTranslation('r020') }}</Col>
                            </Row>
                            <Row type="flex">
                                <Col flex="1" class="flex-middle">{{ selectLibrary.ValCurrentGun }}</Col>
                                <Col flex="1" class="flex-middle">
                                <template v-if="selectLibrary && selectLibrary.ValCurrentGun == 1">{{selectLibrary.ValGun1SingleProdSpotCnt }}</template>
                                <template v-else-if="selectLibrary && selectLibrary.ValCurrentGun == 2">{{selectLibrary.ValGun2SingleProdSpotCnt }}</template>
                                <template v-else>-</template> </Col>
                                <Col flex="1" class="flex-middle">
                                <template v-if="selectLibrary && selectLibrary.ValCurrentGun == 1">{{selectLibrary.ValGun1ScheduleProdMfgCnt }}</template>
                                <template v-else-if="selectLibrary && selectLibrary.ValCurrentGun == 2">{{selectLibrary.ValGun2ScheduleProdMfgCnt }}</template>
                                <template v-else>-</template></Col>
                                <Col flex="1" class="flex-middle">
                                <template v-if="selectLibrary && selectLibrary.ValCurrentGun == 1">{{selectLibrary.ValGun1TotalProdMfgCnt }}</template>
                                <template v-else-if="selectLibrary && selectLibrary.ValCurrentGun == 2">{{selectLibrary.ValGun2TotalProdMfgCnt }}</template>
                                <template v-else>-</template></Col>
                                <Col flex="1" class="flex-middle">
                                <template v-if="selectLibrary && selectLibrary.ValCurrentGun == 1">{{selectLibrary.ValGun1TotalProdSpotCnt }}</template>
                                <template v-else-if="selectLibrary && selectLibrary.ValCurrentGun == 2">{{selectLibrary.ValGun2TotalProdSpotCnt }}</template>
                                <template v-else-if="selectLibrary && selectLibrary.ValCurrentGun == 3">{{selectLibrary.ValGun3TotalProdSpotCnt }}</template>
                                <template v-else-if="selectLibrary && selectLibrary.ValCurrentGun == 4">{{selectLibrary.ValGun4TotalProdSpotCnt }}</template>
                                <template v-else-if="selectLibrary && selectLibrary.ValCurrentGun == 5">{{selectLibrary.ValGun5TotalProdSpotCnt }}</template>
                                <template v-else>-</template></Col>
                                <Col flex="1" class="flex-middle">
                                <template v-if="selectLibrary && selectLibrary.ValCurrentGun == 1">{{selectLibrary.ValGun1StepIncNumCnt }}</template>
                                <template v-else-if="selectLibrary && selectLibrary.ValCurrentGun == 2">{{selectLibrary.ValGun2StepIncNumCnt }}</template>
                                <template v-else-if="selectLibrary && selectLibrary.ValCurrentGun == 3">{{selectLibrary.ValGun3StepIncNumCnt }}</template>
                                <template v-else-if="selectLibrary && selectLibrary.ValCurrentGun == 4">{{selectLibrary.ValGun4StepIncNumCnt }}</template>
                                <template v-else-if="selectLibrary && selectLibrary.ValCurrentGun == 5">{{selectLibrary.ValGun5StepIncNumCnt }}</template>
                                <template v-else>-</template></Col>
                                <Col flex="1" class="flex-middle">
                                <template v-if="selectLibrary && selectLibrary.ValCurrentGun == 1">{{selectLibrary.ValGun1DressedNumCnt }}</template>
                                <template v-else-if="selectLibrary && selectLibrary.ValCurrentGun == 2">{{selectLibrary.ValGun2DressedNumCnt }}</template>
                                <template v-else-if="selectLibrary && selectLibrary.ValCurrentGun == 3">{{selectLibrary.ValGun3DressedNumCnt }}</template>
                                <template v-else-if="selectLibrary && selectLibrary.ValCurrentGun == 4">{{selectLibrary.ValGun4DressedNumCnt }}</template>
                                <template v-else-if="selectLibrary && selectLibrary.ValCurrentGun == 5">{{selectLibrary.ValGun5DressedNumCnt }}</template>
                                <template v-else>-</template></Col>
                                <Col flex="1" class="flex-middle">{{ selectLibrary.ValPrimCapVolt }}</Col>
                            </Row>
                        </div>
                    </Card>
                    <div class="separator-section">
                        <div class="separator-line"></div>
                    </div>
                    <div class="other-line">
                        <Row type="flex" class="row-line table-row-odd">
                            <Col flex="1">
                            </Col>
                            <Col flex="2" class="flex-middle">{{ getTranslation('b018') }}</Col>
                            <Col flex="2" class="flex-middle">{{ getTranslation('b019') }}</Col>
                            <Col flex="2" class="flex-middle">{{ getTranslation('b020') }}</Col>
                            <Col flex="2" class="flex-middle">{{ getTranslation('b021') }}</Col>
                            <Col flex="2" class="flex-middle">{{ getTranslation('b022') }}</Col>
                            <Col flex="2" class="flex-middle">{{ getTranslation('b023') }}</Col>
                            <Col flex="2" class="flex-middle">{{ getTranslation('b024') }}</Col>
                            <Col flex="2" class="flex-middle">{{ getTranslation('b025') }}</Col>
                            <Col flex="2" class="flex-middle">{{ getTranslation('b026') }}</Col>
                            <Col flex="2" class="flex-middle">{{ getTranslation('b027') }}</Col>
                            <Col flex="2" class="flex-middle">{{ getTranslation('b028') }}</Col>
                            <Col flex="2" class="flex-middle">{{ getTranslation('b029') }}</Col>
                            <Col flex="2" class="flex-middle">{{ getTranslation('b030') }}</Col>
                            <Col flex="2" class="flex-middle">{{ getTranslation('b031') }}</Col>
                            <Col flex="2" class="flex-middle">{{ getTranslation('b032') }}</Col>
                            <Col flex="1">
                            </Col>
                        </Row>
                        <Row type="flex" class="row-line">
                            <Col flex="1"><img class="other-img" :src="require('@/assets/img/weld-crr.png')" /></Col>
                            <Col flex="4">
                            </Col>
                            <Col flex="2" class="flex-middle"><Input type="text" size="small" class="input flex-middle"
                                v-model="selectLibrary.CrrPreWeld" /></Col>
                            <Col flex="4">
                            </Col>
                            <Col flex="2" class="flex-middle"><Input type="text" size="small" class="input"
                                v-model="selectLibrary.CrrWeld1" /></Col>
                            <Col flex="2">
                            </Col>
                            <Col flex="2" class="flex-middle"><Input type="text" size="small" class="input"
                                v-model="selectLibrary.CrrWeld2" /></Col>
                            <Col flex="2">
                            </Col>
                            <Col flex="2" class="flex-middle"><Input type="text" size="small" class="input"
                                v-model="selectLibrary.CrrWeld3" /></Col>
                            <Col flex="4">
                            </Col>
                            <Col flex="2" class="flex-middle"><Input type="text" size="small" class="input"
                                v-model="selectLibrary.CrrPostWeld" /></Col>
                            <Col flex="4">
                            </Col>
                            <Col flex="1" class="flex-middle">KA</Col>
                        </Row>
                        <Row type="flex" class="row-line table-row-odd">
                            <Col flex="1"><img class="other-img" :src="require('@/assets/img/weld-time.png')" /></Col>
                            <Col flex="2" class="flex-middle"><Input type="text" size="small" class="input"
                                v-model="selectLibrary.TimPrePress" /></Col>
                            <Col flex="2" class="flex-middle"><Input type="text" size="small" class="input"
                                v-model="selectLibrary.TimMorePress" /></Col>
                            <Col flex="2" class="flex-middle"><Input type="text" size="small" class="input"
                                v-model="selectLibrary.TimPreWeld" /></Col>
                            <Col flex="2" class="flex-middle"><Input type="text" size="small" class="input"
                                v-model="selectLibrary.TimCold0" /></Col>
                            <Col flex="2" class="flex-middle"><Input type="text" size="small" class="input"
                                v-model="selectLibrary.TimAscentWeld" /></Col>
                            <Col flex="2" class="flex-middle"><Input type="text" size="small" class="input"
                                v-model="selectLibrary.TimWeld1" /></Col>
                            <Col flex="2" class="flex-middle"><Input type="text" size="small" class="input"
                                v-model="selectLibrary.TimCold1" /></Col>
                            <Col flex="2" class="flex-middle"><Input type="text" size="small" class="input"
                                v-model="selectLibrary.TimWeld2" /></Col>
                            <Col flex="2" class="flex-middle"><Input type="text" size="small" class="input"
                                v-model="selectLibrary.TimCold2" /></Col>
                            <Col flex="2" class="flex-middle"><Input type="text" size="small" class="input"
                                v-model="selectLibrary.TimWeld3" /></Col>
                            <Col flex="2" class="flex-middle"><Input type="text" size="small" class="input"
                                v-model="selectLibrary.TimDescendWeld" /></Col>
                            <Col flex="2" class="flex-middle"><Input type="text" size="small" class="input"
                                v-model="selectLibrary.TimCold3" /></Col>
                            <Col flex="2" class="flex-middle"><Input type="text" size="small" class="input"
                                v-model="selectLibrary.TimPostWeld" /></Col>
                            <Col flex="2" class="flex-middle"><Input type="text" size="small" class="input"
                                v-model="selectLibrary.TimKeep" /></Col>
                            <Col flex="2" class="flex-middle"><Input type="text" size="small" class="input"
                                v-model="selectLibrary.TimRelease" /></Col>
                            <Col flex="1" class="flex-middle"><template
                                v-if="KindOf62(machine.kind)">cyc</template><template v-else>ms</template></Col>
                        </Row>
                    </div>
                    <div class="separator-section">
                        <div class="separator-line"></div>
                    </div>
                    <div class="table">
                        <Row type="flex">
                            <Col flex="1" class="flex-middle">{{ getTranslation('k226') }}</Col>

                            <Col flex="1" class="flex-middle">{{ getTranslation('k231') }}</Col>
                            <Col flex="1" class="flex-middle">{{ getTranslation('k232') }}</Col>
                            <Col flex="1" class="flex-middle">{{ getTranslation('r021') }}</Col>
                            <Col flex="1" class="flex-middle">{{ getTranslation('r022') }}</Col>
                            <Col flex="1" class="flex-middle">{{ getTranslation('k233') }}</Col>
                            <Col flex="1" class="flex-middle">{{ getTranslation('k234') }}</Col>
                            <Col flex="1" class="flex-middle">{{ getTranslation('k235') }}</Col>
                        </Row>
                        <Row type="flex" class="row-line">
                            <Col flex="1" class="flex-middle">{{ selectLibrary.Vin }}</Col>
                            <Col flex="1" class="flex-middle">{{ selectLibrary.ValPowerCnt }}</Col>
                            <Col flex="1" class="flex-middle">{{ selectLibrary.ValDutyOnTime }}</Col>
                            <Col flex="1" class="flex-middle">{{ selectLibrary.ValPrgExpulsionCnt }}</Col>
                            <Col flex="1" class="flex-middle">{{ selectLibrary.ValSysExpulsionCnt }}</Col>
                            <Col flex="1" class="flex-middle">{{ selectLibrary.ValSecVolt }}</Col>
                            <Col flex="1" class="flex-middle">{{ selectLibrary.ValSecRest }}</Col>
                            <Col flex="1" class="flex-middle">{{ selectLibrary.DispRsv10 }}</Col>
                        </Row>
                    </div>

                </TabPane>
                <TabPane :label="getTranslation('r011')" name="m2" class="custom-tabpane">
                    <div style="width:100%;">
                        <Row type="flex" class="table-row table-header flex-middle">
                            <Col flex="1" class="table-cell" >{{ getTranslation('p079') }}</Col>
                            <Col flex="1" class="table-cell" >{{ getTranslation('b020') }}</Col>
                            <Col flex="1" class="table-cell" >{{ getTranslation('b023') }}</Col>
                            <Col flex="1" class="table-cell" >{{ getTranslation('b025') }}</Col>
                            <Col flex="1" class="table-cell" >{{ getTranslation('b027') }}</Col>
                            <Col flex="1" class="table-cell" >{{ getTranslation('b030') }}</Col>
                        </Row>
                        <Row type="flex" class="table-row table-row-even">
                            <Col flex="1" class="table-cell  flex-middle" >{{ getTranslation('k218') }}（KA）
                            </Col>
                            <Col flex="1" class="table-cell">
                                {{ selectLibrary.ProgramCrrPreWeld }}                               
                            </Col>
                            <Col flex="1" class="table-cell">
                                <div>{{ selectLibrary.ProgramCrrWeld1 }}</div>
                              
                            </Col>
                            <Col flex="1" class="table-cell">
                                <div>{{ selectLibrary.ProgramCrrWeld2 }}({{ getTranslation('b095') }}:{{ selectLibrary.ProgramNumWeldPulse2 }}）</div>                              
                            </Col>
                            <Col flex="1" class="table-cell">
                                <div>{{ selectLibrary.ProgramCrrWeld3 }}</div>                                
                            </Col>
                            <Col flex="1" class="table-cell">
                                <div>{{ selectLibrary.ProgramCrrPostWeld }}</div>
                                                        
                            </Col>
                        </Row>
                        <Row type="flex" class="table-row table-row-odd">
                            <Col flex="1" class="table-cell  flex-middle" >{{ getTranslation('k157') }}
                            </Col>
                            <Col flex="1" class="table-cell">
                                {{ selectLibrary.CrrPreWeld }}                               
                            </Col>
                            <Col flex="1" class="table-cell">
                                <div>{{ selectLibrary.CrrWeld1 }}</div>                               
                            </Col>
                            <Col flex="1" class="table-cell">
                                <div>{{ selectLibrary.CrrWeld2 }}</div>                                
                            </Col>
                            <Col flex="1" class="table-cell">
                                <div>{{ selectLibrary.CrrWeld3 }}</div>                               
                            </Col>
                            <Col flex="1" class="table-cell">
                                <div>{{ selectLibrary.CrrPostWeld }}</div>                                                            
                            </Col>
                        </Row>
                        <Row type="flex" class="table-row table-row-even">
                            <Col flex="1" class="table-cell  flex-middle" >{{ getTranslation('p080') }}  ( KA )                          </Col>
                            <Col flex="1" class="table-cell">
                                /                              
                            </Col>
                            <Col flex="1" class="table-cell">
                                <div>{{ProgramCrrMinWeld1}}<template v-if="selectLibrary && selectLibrary.CurrThdMode ==1">&nbsp;({{ selectLibrary.ProgramCrrMinWeld1 }}%)</template></div>                               
                            </Col>
                            <Col flex="1" class="table-cell">
                                <div>{{ ProgramCrrMinWeld2 }}<template v-if="selectLibrary && selectLibrary.CurrThdMode ==1">&nbsp;({{ selectLibrary.ProgramCrrMinWeld2 }}%)</template></div>                                
                            </Col>
                            <Col flex="1" class="table-cell">
                                <div>{{ ProgramCrrMinWeld3 }}<template v-if="selectLibrary && selectLibrary.CurrThdMode ==1">&nbsp;({{ selectLibrary.ProgramCrrMinWeld3 }}%)</template></div>                               
                            </Col>
                            <Col flex="1" class="table-cell">
                                <div>/</div>                                                            
                            </Col>
                        </Row>
                         <Row type="flex" class="table-row table-row-odd">
                            <Col flex="1" class="table-cell  flex-middle" >{{ getTranslation('p081') }} (  KA )
                            </Col>
                            <Col flex="1" class="table-cell">
                                /                             
                            </Col>
                            <Col flex="1" class="table-cell">
                                <div>{{ ProgramCrrMaxWeld1 }}<template v-if="selectLibrary && selectLibrary.CurrThdMode ==1">&nbsp;({{ selectLibrary.ProgramCrrMaxWeld1 }}%)</template></div>                               
                            </Col>
                            <Col flex="1" class="table-cell">
                                <div>{{ ProgramCrrMaxWeld2 }}<template v-if="selectLibrary && selectLibrary.CurrThdMode ==1">&nbsp;({{ selectLibrary.ProgramCrrMaxWeld2 }}%)</template></div>                                
                            </Col>
                            <Col flex="1" class="table-cell">
                                <div>{{ ProgramCrrMaxWeld3 }}<template v-if="selectLibrary && selectLibrary.CurrThdMode ==1">&nbsp;({{ selectLibrary.ProgramCrrMaxWeld3 }}%)</template></div>                               
                            </Col>
                            <Col flex="1" class="table-cell">
                                <div>/</div>                                                            
                            </Col>
                        </Row>
                        
                         
                    </div>
                    <div style="width:100%">
                        <div ref="recordEcharts" :style="{ width: chartWidth, height: '550px' }"></div>
                    </div>
                </TabPane>
            </Tabs>

            <div class="nav-button nav-next" @click="tabChange(1)" :class="{ disabled: !canNext }">
                <Icon type="ios-arrow-forward" />
            </div>
            </div>
        </div>
        <ExpulsionSetting v-model="expulsionSettingVisible" :propVisible="expulsionSettingVisible" @set-success="setExpulsionSuccess"></ExpulsionSetting>

    </Modal>
</template>
<script>
import { API_URL } from '@/constants/const.js'
import axios from 'axios';
import { Modal, Row, Col, Input, TabPane, Tabs, Card, Icon } from 'view-design';
import { mapGetters } from 'vuex'
import { postJsError, formatShorTime,KindOf62, formatDecimals,formatUTCDateTime } from '@/util/util.js'
import ExpulsionSetting from '@/components/ExpulsionSetting.vue';
import FileSaver from "file-saver";
import * as XLSX from 'xlsx';
import LoadingBar from '@/components/LoadingBar.vue';
export default {
    name: 'MachineEdit', // 组件名称
    components: {
        Modal, Row, Col, Input, TabPane, Tabs, Card, Icon, ExpulsionSetting,LoadingBar
    },
    props: {
        propVisible: Boolean,
        recordId: String,
        allItem: Array,
    },
    data() {
        return {
            modalLoading: true,
            mac: '',
            record: {},
            selectLibrary: {},
            machine: {},
            myChart: null,
            chartWidth: '100%',
            yAxisDefine: [],
            selectMode: "m1",
            curvesData: null,
            firstTime: false,
            selectedRecorId: '',
            zoomStart: 0,
            zoomEnd: 100,
            expulsionPoint: null,
            expulsionSettingVisible: false,
            showExpulsionPoint: false,
            productline:{},
            startPos:null,
            xAxis:[],
            loading:false,
        }
    },
    computed: {
        ...mapGetters(['getTranslation']),
        visible: {
            get() { return this.propVisible },
            set(val) { this.$emit('input', val) }
        },
        title() {
            let rs = this.getTranslation('b176');
            if (this.selectLibrary && this.selectLibrary) {
                rs += ' [' + this.formatShorTime(this.selectLibrary.created_string) + ']' +
                    ' | '+this.getTranslation('k259')+'[' + this.selectLibrary.SpotId + ']' +
                    ' | '+this.getTranslation('b006')+'[' + this.selectLibrary.NoWeldProgram + ']'+
                    ' | '+this.getTranslation('k230')+'[' + this.selectLibrary.ValCurrentGun + ']'

            }
            return rs
        },
        canPre() {
            let can = false;
            let index = -1;
            this.allItem.forEach((oneItem, key) => {
                if (oneItem == this.selectedRecorId) {
                    index = key
                }
            })
            if (index > 0) {
                can = true;
            }
            return can
        },
        canNext() {
            let can = false;
            let index = -1;
            this.allItem.forEach((oneItem, key) => {
                if (oneItem == this.selectedRecorId) {
                    index = key
                }
            })
            if (index < this.allItem.length - 1) {
                can = true;
            }
            return can
        },
        unit() {
            let rs = 'KA';
            if (this.selectLibrary && this.selectLibrary.CurrThdMode && this.selectLibrary.CurrThdMode == 1) {
                rs = '%';
            }
            return rs;
        },
        alarmList(){
            let rs = '';
            let nums = 0;
            if (this.selectLibrary && this.selectLibrary.AlarmList && this.selectLibrary.AlarmList.length >0){
                this.selectLibrary.AlarmList.forEach((alarmItem)=>{
                    if (nums >0){
                        rs += " | "
                    }                    
                    rs += alarmItem.content;
                    nums +=1;
                })
            }
            return rs;
        },
        ProgramCrrMinWeld1(){
            let rs = 0
            if (this.selectLibrary && this.selectLibrary.ProgramCrrMinWeld1 > 0){
                if (this.selectLibrary && this.selectLibrary.CurrThdMode && this.selectLibrary.CurrThdMode == 1) {                    
                    rs = formatDecimals(this.selectLibrary.ProgramCrrMinWeld1 * this.selectLibrary.ProgramCrrWeld1/100)
                }else {
                    rs = this.selectLibrary.ProgramCrrMinWeld1
                }
            }
            return rs;
        },
        ProgramCrrMinWeld2(){
            let rs = 0
            if (this.selectLibrary && this.selectLibrary.ProgramCrrMinWeld2 > 0){
                if (this.selectLibrary && this.selectLibrary.CurrThdMode && this.selectLibrary.CurrThdMode == 1) {
                    rs = formatDecimals(this.selectLibrary.ProgramCrrMinWeld2 * this.selectLibrary.ProgramCrrWeld2/100)
                }else {
                    rs = this.selectLibrary.ProgramCrrMinWeld2
                }
            }
            return rs;
        },
        ProgramCrrMinWeld3(){
            let rs = 0
            if (this.selectLibrary && this.selectLibrary.ProgramCrrMinWeld3 > 0){
                if (this.selectLibrary && this.selectLibrary.CurrThdMode && this.selectLibrary.CurrThdMode == 1) {
                    rs = formatDecimals(this.selectLibrary.ProgramCrrMinWeld3 * this.selectLibrary.ProgramCrrWeld3/100)
                }else {
                    rs = this.selectLibrary.ProgramCrrMinWeld3
                }
            }
            return rs;
        },
        ProgramCrrMaxWeld1(){
            let rs = 0
            if (this.selectLibrary && this.selectLibrary.ProgramCrrMaxWeld1 > 0){
                if (this.selectLibrary && this.selectLibrary.CurrThdMode && this.selectLibrary.CurrThdMode == 1) {                    
                    rs = formatDecimals(this.selectLibrary.ProgramCrrMaxWeld1 * this.selectLibrary.ProgramCrrWeld1/100)
                }else {
                    rs = this.selectLibrary.ProgramCrrMaxWeld1
                }
            }
            return rs;
        },
        ProgramCrrMaxWeld2(){
            let rs = 0
            if (this.selectLibrary && this.selectLibrary.ProgramCrrMaxWeld2 > 0){
                if (this.selectLibrary && this.selectLibrary.CurrThdMode && this.selectLibrary.CurrThdMode == 1) {                    
                    rs = formatDecimals(this.selectLibrary.ProgramCrrMaxWeld2 * this.selectLibrary.ProgramCrrWeld1/100)
                }else {
                    rs = this.selectLibrary.ProgramCrrMaxWeld2
                }
            }
            return rs;
        },
        ProgramCrrMaxWeld3(){
            let rs = 0
            if (this.selectLibrary && this.selectLibrary.ProgramCrrMaxWeld3 > 0){
                if (this.selectLibrary && this.selectLibrary.CurrThdMode && this.selectLibrary.CurrThdMode == 1) {                    
                    rs = formatDecimals(this.selectLibrary.ProgramCrrMaxWeld3 * this.selectLibrary.ProgramCrrWeld1/100)
                }else {
                    rs = this.selectLibrary.ProgramCrrMaxWeld3
                }
            }
            return rs;
        },

    },
    watch: {
        visible(newVal) {
            if (newVal) {
                if (this.recordId != '') {
                    this.selectedRecorId = this.recordId;
                    this.showExpulsionPoint = localStorage.getItem('running.showExpulsionPoint') != '0';
                    this.getDetail(this.recordId)
                }
            }
        }
    },

    created() {
        this.mac = this.$route.query.mac

    },
    methods: {
        initCurves() {
            let _this = this;
            this.$nextTick(() => {
                const parentWidth = this.$refs.recordEcharts.offsetWidth;
                this.chartWidth = `${parentWidth}px`;
                this.myChart = this.$echarts.init(this.$refs.recordEcharts);
                this.yAxisDefine = [
                    {
                        name: this.getTranslation('r081'),
                        show: true,
                        offset: 0,
                        position: 'left',
                        nameLocation: 'middle',
                        axisLine: { onZero: true },
                        type: 'value',
                        nameTextStyle: {
                            color: '#f00'
                        },
                        axisLabel: {                
                            color: '#f00'              
                        }
                    },
                    {
                        name: this.getTranslation('r082'),
                        show: true,
                        offset: 0,
                        position: 'right',
                        nameLocation: 'middle',
                        axisLine: { onZero: true },
                        type: 'value',
                        nameTextStyle: {
                            color: '#00f'
                        },
                        axisLabel: {               
                            color: '#00f'              
                        }
                    },
                    {
                        name: this.getTranslation('r083'),
                        show: true,
                        offset: 20,
                        position: 'left',
                        nameLocation: 'middle',
                        axisLine: { onZero: true },
                        type: 'value',
                        nameTextStyle: {
                            color: '#0f0'
                        },
                        axisLabel: {                
                            color: '#0f0' 
                        }
                    },
                    {
                        name: this.getTranslation('r084'),
                        show: true,
                        offset: 20,
                        position: 'right',
                        nameLocation: 'middle',
                        axisLine: { onZero: true },
                        type: 'value',
                        nameTextStyle: {
                            color: '#FFA500'
                        },
                        axisLabel: {               
                            color: '#FFA500'                
                        }
                    }
                ];
                this.myChart.setOption({
                    title: { text: "weld-curve", show: false },
                    toolbox: {
                        feature: {
                            myTool2: {
                            show: true,
                            title: this.getTranslation('r118'),//飞溅点设置
                            icon: 'path://M512 192C282.8 192 85.3 328.5 0 512c85.3 183.5 282.8 320 512 320s426.7-136.5 512-320C938.7 328.5 741.2 192 512 192z M512 746.7c-129.8 0-234.7-104.9-234.7-234.7S382.2 277.3 512 277.3 746.7 382.2 746.7 512 641.8 746.7 512 746.7z M512 384c-70.7 0-128 57.3-128 128s57.3 128 128 128 128-57.3 128-128S582.7 384 512 384z',
                            onclick: function () {
                                    _this.expulsionSetting();
                                },
                            },
                            dataView: { 
                                show: true,
                                lang: ['数据视图', this.getTranslation('m063'),  this.getTranslation('k025')], // 修改按钮文字
                                // [关键] 1. 重绘表格样式 (将数据渲染成带格式的Html表格)
                                optionToContent: function(opt) {                                    
                                    let axisData = opt.xAxis[0].data; // X轴数据
                                    let series = opt.series;          // 系列数据
                                    let html = '<table border="1" id="my-data-table"><thead><tr><th>项目</th>';
                                    
                                    // 动态生成表头
                                    series.forEach(s => { html += `<th>${s.name}</th>`; });
                                    html += `</tr></thead><tbody>`;
                                    
                                    // 填充数据
                                    axisData.forEach((item, idx) => {
                                        html += `<tr><td>${item}</td>`;
                                        series.forEach(s => {
                                            html += `<td>${s.data[idx] ?? '-'}</td>`;
                                        });
                                        html += `</tr>`;
                                    });
                                    html += `</tbody></table>`;
                                    return html;
                                },
                                // [关键] 2. 重写刷新/导出逻辑
                                contentToOption: function() {                  
                                    // 利用 xlsx 库解析当前显示的表格并导出
                                    let workbook = XLSX.utils.table_to_book(document.getElementById("my-data-table"), { raw: true });
                                    let excelData = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
                                    try {
                                        FileSaver.saveAs(new Blob([excelData], { type: "application/octet-stream" }), "record_"+ formatUTCDateTime(new Date()) +".xlsx");
                                    } catch (e) { console.error("导出失败", e); }
                                }
                            },
                            saveAsImage: {},
                            
                        }
                    },
                    tooltip: {
                        trigger: 'axis',
                        formatter: (params) => this.formatCurveTooltip(params)
                    },
                    grid: {
                        left: '35px',
                        right: '45px',
                        top: '40px'
                    },
                    yAxis: this.yAxisDefine,
                    dataZoom: [{
                        id: 'dataZoomX',
                        type: 'slider',
                        xAxisIndex: 0,
                        bottom: 30,
                        filterMode: 'empty',
                        showDataShadow: true,
                        start: this.zoomStart,
                        end: this.zoomEnd
                    },
                        {
                            type: 'slider',
                            xAxisIndex: 0,
                            bottom: 30,
                            filterMode: 'empty',
                            showDataShadow: true
                        },
                        {
                            type: 'slider',
                            yAxisIndex: [0, 1, 2, 3],
                            filterMode: 'empty',
                            right: 0,
                            showDataShadow: true
                        },
                    ],
                    xAxis: {
                        data: []
                    },
                    legend: {
                        data: []
                    },
                    series: [{
                        name: this.getTranslation('r081'),
                        type: 'line',
                        data: []
                    }],
                    graphic: [
                        {
                            id: 'selectionRect',
                            type: 'rect',
                            invisible: true,
                            silent: true,
                            shape: {
                                x: 0,
                                y: 0,
                                width: 0,
                                height: 0
                            },
                            style: {
                                fill: 'rgba(135, 206, 250, 0.3)',
                                stroke: '#1E90FF',
                                lineWidth: 1
                            },
                            z: 100
                        }
                    ]
                });
                this.setBrush();
            })
        },
        async getDetail(id) {
            this.loading = true;
            this.$emit('change-record', id);
            let url = API_URL["recordDetail"];
            let params = {
                id: id,
                mac: this.mac
            }
            let res = null;
            try {
                res = await axios.get(url, {
                    params: params,
                    timeout:60000,
                })
            } catch (err) {
                postJsError(err)
                this.$Message.error(this.getTranslation('c001'));
            } finally {
                this.loading = false;
            }
            
            if(res){
                    if (res && res.data && res.data.code == 200) {
                        this.selectLibrary = res.data.data.record;
                        this.machine = res.data.data.machine.CurrentMachine;
                        this.curvesData = res.data.data.curves;
                        this.xAxis = res.data.data.xAxis;
                        this.expulsionPoint = res.data.data.expulsionPoint||[];
                        this.productline = res.data.data.productline||{};
                        this.createCurves(this.curvesData)
                    } else if (res && res.data && res.data.msg) {
                        this.$Message.error(res.data.msg);
                    } else {
                        this.$Message.error(this.getTranslation('c001'));
                    }
                }
            this.loading = false;
               
        },
        ok() {
            this.visible = false
            this.resetModal();
        },
        resetModal() {
            this.$nextTick(() => {
                this.modalLoading = true;
            });
        },
        formatCurveTooltip(params) {
            const lines = [];
            const tooltipParams = Array.isArray(params) ? params : [params];
            if (!tooltipParams.length) {
                return '';
            }

            const firstPoint = tooltipParams[0];
            lines.push(firstPoint.axisValueLabel || firstPoint.name || '');
            tooltipParams.forEach((onePoint) => {
                const value = onePoint && onePoint.value !== undefined && onePoint.value !== null ? onePoint.value : '-';
                lines.push(`${onePoint.marker || ''}${onePoint.seriesName}: ${value}`);
            });

            const pointIndex = Number(firstPoint.dataIndex);
            const hasAnomaly = Array.isArray(this.expulsionPoint) && this.expulsionPoint.some((oneIndex) => Number(oneIndex) === pointIndex);
            if (hasAnomaly) {
                lines.push(this.getTranslation('m214'));
            }

            return lines.join('<br/>');
        },
        createCurves(data) {
            if (!this.myChart) {
                this.initCurves();
            }
            this.$nextTick(() => {
                let aSeries = [];
                let aLegend = [];
                if (data.current) {
                    aLegend.push(this.getTranslation('r081'));
                    aSeries.push({
                        name: this.getTranslation('r081'),
                        type: 'line',
                        tiled: '总量',
                        showSymbol: false,
                        // smooth: true,
                        color: '#f00',
                        lineStyle: { width: 1 },
                        yAxisIndex: 0,
                        data: data.current
                    });
                    this.yAxisDefine[0].show = true;
                } else {
                    this.yAxisDefine[0].show = false;
                    aSeries.push({
                        type: 'line',
                        name: this.getTranslation('r081'),
                        data: []
                    });
                }
                if (data.voltage) {
                    aLegend.push(this.getTranslation('r082'));
                    aSeries.push({
                        name: this.getTranslation('r082'),
                        type: 'line',
                        tiled: '总量',
                        showSymbol: false,
                        // smooth: true,
                        color: '#00f',
                        lineStyle: { width: 1 },
                        yAxisIndex: 1,
                        data: data.voltage
                    });
                    this.yAxisDefine[1].show = true;
                } else {
                    this.yAxisDefine[1].show = false;
                    aSeries.push({
                        name: this.getTranslation('r082'),
                        type: 'line',
                        data: []
                    });
                }
                if (data.resistance) {
                    aLegend.push(this.getTranslation('r083'));
                    const resistanceSeries = {
                        name: this.getTranslation('r083'),
                        type: 'line',
                        tiled: '总量',
                        showSymbol: false,
                        // smooth: true,
                        color: '#0f0',
                        lineStyle: { width: 1 },
                        yAxisIndex: 2,
                        data: data.resistance,
                        markPoint: {
                            data: []
                        }
                    };
                    aSeries.push(resistanceSeries);
                    this.yAxisDefine[2].show = true;
                    if (Array.isArray(this.expulsionPoint) && this.expulsionPoint.length > 0 && this.showExpulsionPoint) {
                        var anomalies = [];
                        for (let i = 0; i < this.expulsionPoint.length; i++) {
                            const pointIndex = Number(this.expulsionPoint[i]);
                            if (Number.isNaN(pointIndex) || pointIndex < 0 || pointIndex >= data.resistance.length) {
                                continue;
                            }
                            anomalies.push({
                                name: "飞溅发生点",
                                value: data.resistance[pointIndex] || 0,
                                xAxis: pointIndex,
                                yAxis: data.resistance[pointIndex] || 0,
                                itemStyle: { color: '#e74c3c' },                                
                                
                            });
                        }
                        if (anomalies.length > 0) {
                            resistanceSeries.markPoint = {
                                data: anomalies,
                                name: "飞溅发生点",
                                symbol: 'circle',
                                symbolSize: 8,
                                itemStyle: { color: '#e74c3c' },
                                label: { show: false },
                            };
                        }

                    }
                } else {
                    this.yAxisDefine[2].show = false;
                    aSeries.push({
                        name: this.getTranslation('r083'),
                        type: 'line',
                        data: []
                    });
                }
                if (data.press) {
                    aLegend.push(this.getTranslation('r084'));
                    aSeries.push({
                        name: this.getTranslation('r084'),
                        type: 'line',
                        tiled: '总量',
                        showSymbol: false,
                        // smooth: true,
                        color: '#FFA500',
                        lineStyle: { width: 1 },
                        yAxisIndex: 3,
                        data: data.press
                    });
                    this.yAxisDefine[3].show = true;
                } else {
                    this.yAxisDefine[3].show = false;
                    aSeries.push({
                        name: this.getTranslation('r084'),
                        type: 'line',
                        data: []
                    });
                }
                this.myChart.setOption({
                    legend: {
                        data: aLegend,
                        bottom: 0
                    },
                    yAxis: this.yAxisDefine,
                    xAxis: {
                        axisLine: { onZero: true },
                        type: 'category',
                        boundaryGap: false,
                        splitLine: {
                            show: true
                        },
                        data: this.xAxis
                    },
                    series: aSeries
                });
            })
        },
        formatShorTime(str) {
            return formatShorTime(str)
        },
        async tabChange(index) {            
            let inindex = -1;
            this.allItem.forEach((oneItem, key) => {
                if (oneItem == this.selectedRecorId) {
                    inindex = key
                }
            })
            let realIndex = inindex + index;
            if (this.allItem[realIndex]) {
                this.selectedRecorId = this.allItem[realIndex]
                await this.getDetail(this.selectedRecorId)
            }
            

        },
        isInDataZoomArea(x, y) {
            const gridModel = this.myChart.getModel().getComponent('grid', 0);
            if (!gridModel) return false;
            const grid = gridModel.coordinateSystem;
            const rect = grid.getRect();            
            // right-side y-axis dataZoom slider area
            if (x > rect.x + rect.width) return true;
            // bottom x-axis dataZoom slider area (below grid + legend)
            if (y > rect.y + rect.height + 35) return true;
            return false;
        },
        setBrush() {
             const zr = this.myChart.getZr();
            // Remove only our own previous handlers, leaving ECharts' internal
            // dataZoom slider handlers intact
            if (this._brushMousedown) zr.off('mousedown', this._brushMousedown);
            if (this._brushMousemove) zr.off('mousemove', this._brushMousemove);
            if (this._brushMouseup) zr.off('mouseup', this._brushMouseup);
            if (this._brushDblclick) zr.off('dblclick', this._brushDblclick);

            this._brushMousedown = (e) => {
                if (e.event.which !== 1) return;
                if (this.isInDataZoomArea(e.offsetX, e.offsetY)) return;

                const inGrid = this.myChart.containPixel({ gridIndex: 0 }, [e.offsetX, e.offsetY]);
                if (!inGrid) return;

                this.isSelecting = true;
                this.startPos = { x: e.offsetX, y: e.offsetY };

                const gridModel = this.myChart.getModel().getComponent('grid', 0);
                if (gridModel) {
                const grid = gridModel.coordinateSystem;
                const rect = grid.getRect();
                this.myChart.setOption({
                    graphic: {
                    id: 'selectionRect',
                    invisible: false,
                    shape: {
                        x: this.startPos.x,
                        y: rect.y,
                        width: 0,
                        height: rect.height
                    }
                    }
                });
                }
            };

            this._brushMousemove = (e) => {
                if (this.isSelecting && this.startPos) {
                    const width = e.offsetX - this.startPos.x;

                    this.myChart.setOption({
                        graphic: {
                            id: 'selectionRect',
                            shape: { width }
                        }
                    });
                }
            };

            this._brushMouseup = (e) => {
                if (this.isSelecting && this.startPos) {
                    this.isSelecting = false;
                    const endPos = { x: e.offsetX, y: e.offsetY };

                    const width = Math.abs(endPos.x - this.startPos.x);
                    if (width > 10) {
                        this.applyZoom(this.startPos.x, endPos.x);
                    }

                    // 隐藏选择框
                    this.myChart.setOption({
                        graphic: {
                            id: 'selectionRect',
                            invisible: true
                        }
                    });

                    this.startPos = null;
                }
            };

            this._brushDblclick = (e) => {
                if (this.isInDataZoomArea(e.offsetX, e.offsetY)) return;
                const inGrid = this.myChart.containPixel({ gridIndex: 0 }, [e.offsetX, e.offsetY]);
                if (!inGrid) return;

                this.myChart.dispatchAction({
                type: 'dataZoom',
                dataZoomIndex: [0, 1, 2],
                start: 0,
                end: 100
                });
            };

            zr.on('mousedown', this._brushMousedown);
            zr.on('mousemove', this._brushMousemove);
            zr.on('mouseup', this._brushMouseup);
            zr.on('dblclick', this._brushDblclick);
        },
        applyZoom(startPixel, endPixel) {
            const xAxis = this.myChart.getModel().getComponent('xAxis', 0);
            if (!xAxis) return;

            const axis = xAxis.axis;
            const pixelExtent = axis.getGlobalExtent();
            const minX = Math.min(startPixel, endPixel);
            const maxX = Math.max(startPixel, endPixel);

            // 确保在轴范围内
            const clampedMin = Math.max(minX, pixelExtent[0]);
            const clampedMax = Math.min(maxX, pixelExtent[1]);

            if (clampedMax <= clampedMin) return;

            // 计算百分比
            const startPercent = (clampedMin - pixelExtent[0]) / (pixelExtent[1] - pixelExtent[0]) * 100;
            const endPercent = (clampedMax - pixelExtent[0]) / (pixelExtent[1] - pixelExtent[0]) * 100;

            this.myChart.dispatchAction({
                type: 'dataZoom',
                dataZoomId: 'dataZoomX',
                start: startPercent,
                end: endPercent
            });
           

        },
        expulsionSetting(){
            this.expulsionSettingVisible = true;
        },
        setExpulsionSuccess(){
             this.showExpulsionPoint = localStorage.getItem('running.showExpulsionPoint') != '0';
            this.createCurves(this.curvesData)
        },
        KindOf62(kind){
            return KindOf62(kind)
        }

    },

}



</script>
<style>
.row-line .input .ivu-input {
    text-align: center;
}
</style>
<style scoped>
@import url('../../../assets/style/list.css');
@import url('../../../assets/style/tab.css');



.normal-row {
    margin-bottom: 5px;
}

.normal-row .input-field {
    width: 95%;
}

.other-img {
    width: 14px;
}

.row-line {
    margin: 5px 0;
}

.row-line .input {
    width: 90%;
    text-align: center;
}

/* 表格边框样式 */
.table {
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    overflow: hidden;
}

.tab-navigation-container {
    position: relative;
}

.nav-button {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.3);
    border-radius: 50%;
    cursor: pointer;
    transition: all 0.3s ease;
    color: white;
    font-size: 20px;
    z-index: 10;
}

.nav-button:hover:not(.disabled) {
    background-color: rgba(0, 0, 0, 0.5);
    transform: translateY(-50%) scale(1.1);
}

.nav-button.disabled {
    opacity: 0.3;
    cursor: not-allowed;
}

.nav-prev {
    left: -10px;
}

.nav-next {
    right: -10px;
}

.custom-tabs {
    width: 100%;
}

.table .ivu-row {
    border-bottom: 1px solid #e8e8e8;
}

.table .ivu-col {
    border-right: 1px solid #e8e8e8;
    padding: 8px 4px;
    min-height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.table .ivu-row:first-child .ivu-col {
    background-color: #f5f5f5;
    font-weight: bold;
}

/* 针对 disabled Input 组件的样式 */
::v-deep(.ivu-input.ivu-input-disabled),
::v-deep(.ivu-input[disabled]) {
    color: #999 !important;
    background-color: #f8f9fa !important;
    border-color: #ced4da !important;
    opacity: 1 !important;
    -webkit-text-fill-color: #999 !important;
}
/* 页眉样式 */
.record-header {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  column-gap: 12px;
  row-gap: 4px;
  padding: 4px 8px;
  margin-bottom: 8px;
  background: linear-gradient(180deg, #f8f9fa 0%, #eef0f2 100%);
  border-bottom: 2px solid #d0d5dd;
  border-radius: 4px 4px 0 0;
  font-size: 13px;
}

.record-header-alarm {
  background: linear-gradient(180deg, #fff5f5 0%, #ffe0e0 100%);
  border-bottom-color: #ff4d4f;
}

.header-item {
  display: inline-flex;
  align-items: baseline;
  gap: 4px;
  white-space: nowrap;
}

.header-label {
  color: #8c8c8c;
  font-size: 12px;
  font-weight: 400;
}

.header-label::after {
  content: ':';
}

.header-value {
  color: #262626;
  font-size: 13px;
  font-weight: 600;
}

.header-code {
  color: #1890ff;
  font-size: 14px;
  font-weight: 700;
}

.header-alarm-value {
  color: #ff4d4f;
  font-weight: 700;
}

.header-divider {
  color: #d9d9d9;
  font-size: 14px;
  user-select: none;
}
</style>